// src/PageTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./Analytics";

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null; // this component doesn't render anything
}